module.exports = __webpack_public_path__ + "img/instruction-step1.a245c3cd.png";